import createIcon from '../../createIcon';

/**
 * @component @name LocalBar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNVYzSDNWNUwxMSAxNFYxOUg2VjIxSDE4VjE5SDEzVjE0TDIxIDVaTTcuNDMgN0w1LjY2IDVIMTguMzVMMTYuNTcgN0g3LjQzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalBar = createIcon('LocalBar', [
  [
    'path',
    {
      d: 'M21 5V3H3V5L11 14V19H6V21H18V19H13V14L21 5ZM7.43 7L5.66 5H18.35L16.57 7H7.43Z',
      key: '78gfij',
    },
  ],
]);

export default LocalBar;
